import {fromJS} from 'immutable';
import {combineReducers} from 'redux-immutable';
import {
    localization,
    bootstrap as bootstrapLocalization
} from 'epic-localization/src/client/reducers/localization.reducer';
import config from './config';
import news from './news.reducer';
import user from './user.reducer';
import overview from './overview';
import page from './page.reducer';
import influencer from './influencer.reducer';
import settings from './settings.reducer';
import nav from './nav.reducer';
import dashboard from './dashboard';
import eula from './eula.reducer';
import error from './error.reducer';
import payout from './payout';
import tax from './tax';
import alerts from './alerts.reducer';
import activeUsers from './fortnite-game/activeUsers.reducer';
import activeUsersOverview from './fortnite-game/activeUsersOverview.reducer';
import games from './games.reducer';
import averagePlayTime from './fortnite-game/averagePlayTime.reducer';
import returnPlayers from './fortnite-game/returnPlayers.reducer';
import oauth from './oauth.reducer';
import myOverallHighlights from './fortnite-game/myOverallHighlights.reducer';
import myTopPerformingGames from './fortnite-game/myTopPerformingGames.reducer';
import myTop10Games from './fortnite-game/myTop10Games.reducer';
import lifetimePlays from './fortnite-game/lifetimePlays.reducer';
import performance from './fortnite-game/performance.reducer';
import talon from './talon';
import rewards from './fortnite-game/rewards.reducer';
import rewardsTop10Games from './fortnite-game/rewardsTop10Games.reducer';
import gameXp from './fortnite-game/gameXp.reducer';
import gameXpHighlights from './fortnite-game/gameXpHighlights.reducer';
import playrate from './fortnite-game/playrate.reducer';

import 'epic-diesel-common/src/redux'; // Common reducers

const reducers = {
    localization,
    news,
    user,
    overview,
    page,
    influencer,
    settings,
    nav,
    dashboard,
    config,
    eula,
    error,
    payout,
    tax,
    alerts,
    activeUsers,
    activeUsersOverview,
    games,
    averagePlayTime,
    returnPlayers,
    oauth,
    myOverallHighlights,
    myTopPerformingGames,
    myTop10Games,
    lifetimePlays,
    performance,
    talon,
    rewards,
    rewardsTop10Games,
    gameXp,
    gameXpHighlights,
    playrate
};

const bootstrapReducers = [bootstrapLocalization];

export function bootstrap(dataPreload, pluginBootstraps) {
    let bootstrapState = fromJS({});
    for (const bootstrapReducer of bootstrapReducers) {
        bootstrapState = bootstrapState.merge(bootstrapReducer(dataPreload));
    }
    bootstrapState = bootstrapState.merge({
        news: dataPreload.news,
        user: dataPreload.user,
        overview: dataPreload.overview,
        config: dataPreload.config,
        influencer: dataPreload.influencer,
        talon: dataPreload.talon
    });
    if (pluginBootstraps) {
        // Use boostraps from plugin registry
        for (const pluginBootstrap of pluginBootstraps) {
            if (pluginBootstrap.bootstrap) {
                bootstrapState = bootstrapState.merge(pluginBootstrap.bootstrap(dataPreload));
            }
        }
    }
    return bootstrapState;
}

export function createReducer(extraReducers) {
    return combineReducers({
        ...reducers,
        ...extraReducers
    });
}
